import { render, staticRenderFns } from "./IncreaseNumber.vue?vue&type=template&id=b89b6808&"
import script from "./IncreaseNumber.vue?vue&type=script&lang=js&"
export * from "./IncreaseNumber.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../var/task/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/var/task/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('b89b6808')) {
      api.createRecord('b89b6808', component.options)
    } else {
      api.reload('b89b6808', component.options)
    }
    module.hot.accept("./IncreaseNumber.vue?vue&type=template&id=b89b6808&", function () {
      api.rerender('b89b6808', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "tmp/tmp-2vb8QIjivVl6o/JS/comp/IncreaseNumber.vue"
export default component.exports